var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import Quill from 'quill';
import { forwardRef, useEffect, } from 'react';
import InputWrapper from './input-wrapper';
import 'quill/dist/quill.snow.css';
import './editor.less';
const Editor = forwardRef(function Input(_a, ref) {
    var { id, label, required, errorMessage, onChange, initialValue, wasValidated, readOnly } = _a, props = __rest(_a, ["id", "label", "required", "errorMessage", "onChange", "initialValue", "wasValidated", "readOnly"]);
    useEffect(() => {
        const q = new Quill(`#editor-${id}`, {
            modules: {
                toolbar: readOnly
                    ? false
                    : [
                        ['bold', 'italic', 'underline'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        ['link'],
                    ],
            },
            theme: 'snow',
            readOnly,
        });
        if (initialValue) {
            if (typeof initialValue === 'string') {
                q.setContents([{ insert: initialValue }]);
            }
            else {
                q.setContents(initialValue);
            }
        }
        q.on('text-change', () => {
            if (onChange) {
                onChange({
                    target: {
                        name: id,
                        value: q.getContents().ops,
                    },
                });
            }
        });
    }, []);
    const isInvalid = !!errorMessage;
    return (_jsx(InputWrapper, { label: label, id: id, errorMessage: errorMessage, required: required, children: _jsx("div", Object.assign({}, props, { className: classNames('editor form-control rounded-0 border-top', {
                'border-danger is-invalid': isInvalid,
                'is-valid border-success': wasValidated && !isInvalid,
            }), id: `editor-${id}`, ref: ref })) }));
});
export default Editor;
